import { type AttachmentResponseDto } from '@issuemanager/api-client';
import { AttachmentType } from '@issuemanager/constants';
import { useMemo } from 'react';

export const useGroupedAttachments = (
  attachments: AttachmentResponseDto[],
): {
  regularAttachments: AttachmentResponseDto[];
  approvalAttachments: AttachmentResponseDto[];
} =>
  useMemo(() => {
    const result = {
      attachments: [] as AttachmentResponseDto[],
      approvalAttachments: [] as AttachmentResponseDto[],
    };

    for (const attachment of attachments) {
      switch (attachment.attachmentType) {
        case AttachmentType.ATTACHMENT:
        case undefined:
          result.attachments.push(attachment);
          break;
        case AttachmentType.APPROVAL:
          result.approvalAttachments.push(attachment);
          break;
      }
    }

    return {
      regularAttachments: result.attachments,
      approvalAttachments: result.approvalAttachments,
    };
  }, [attachments]);
